<template>
  <ion-page>
    <ion-header class="ion-no-border">
      <ion-toolbar class="transparent-toolbar">
        <ion-buttons slot="start">
          <ion-button @click="goTo('/dosen')">
            <ion-icon :icon="arrowBackOutline" color="dark"></ion-icon>
          </ion-button>
        </ion-buttons>
        <ion-title class="welcome-title">Data <span class="highlight">Mahasiswa</span></ion-title>
      </ion-toolbar>
    </ion-header>

    <ion-content class="ion-padding dashboard-container">
      <div class="header-action">
        <p>Daftar mahasiswa terdaftar</p>
        <button class="btn-primary-small" @click="showAddModal = true">
          <ion-icon :icon="addOutline"></ion-icon> Tambah
        </button>
      </div>

      <div class="student-list" v-if="!isLoading">
        <div v-if="students.length === 0" class="empty-state">
          <p>Belum ada data mahasiswa.</p>
        </div>
        <div v-for="std in students" :key="std.id" class="student-card glass-effect">
          <div class="std-info">
            <h3>{{ std.nama }}</h3>
            <p>{{ std.npm }}</p>
          </div>
          <button class="btn-danger-small" @click="deleteStudent(std.id)">
            <ion-icon :icon="trashOutline"></ion-icon>
          </button>
        </div>
      </div>
      <div v-else class="ion-text-center ion-margin-top">
        <p>Memuat data...</p>
      </div>

      <!-- Modal Tambah Mahasiswa -->
      <div v-if="showAddModal" class="modal-overlay">
        <div class="modal-content glass-effect">
          <h3>Tambah Mahasiswa</h3>
          <div class="input-group">
            <label>NPM</label>
            <input type="text" v-model="newStudent.npm" placeholder="Contoh: 22001001" class="custom-input"/>
          </div>
          <div class="input-group">
            <label>Nama Lengkap</label>
            <input type="text" v-model="newStudent.nama" placeholder="Contoh: Budi Santoso" class="custom-input"/>
          </div>
          
          <div class="modal-actions">
            <button class="btn-outline" @click="showAddModal = false">Batal</button>
            <button class="btn-primary-small" @click="saveStudent" :disabled="isSaving">
              {{ isSaving ? 'Menyimpan...' : 'Simpan' }}
            </button>
          </div>
        </div>
      </div>
    </ion-content>
  </ion-page>
</template>

<script>
import { 
  IonPage, IonHeader, IonToolbar, IonTitle, IonContent, IonButtons, IonButton, IonIcon
} from '@ionic/vue';
import { useRouter } from 'vue-router';
import { ref, onMounted } from 'vue';
import { 
  arrowBackOutline, addOutline, trashOutline 
} from 'ionicons/icons';
import { db } from '../firebase';
import { collection, getDocs, addDoc, deleteDoc, doc, serverTimestamp, query, orderBy } from 'firebase/firestore';

export default {
  name: 'DosenMahasiswa',
  components: {
    IonPage, IonHeader, IonToolbar, IonTitle, IonContent, IonButtons, IonButton, IonIcon
  },
  setup() {
    const router = useRouter();
    const students = ref([]);
    const isLoading = ref(true);
    const showAddModal = ref(false);
    const isSaving = ref(false);
    
    const newStudent = ref({
      npm: '',
      nama: ''
    });

    const loadStudents = async () => {
      isLoading.value = true;
      try {
        const q = query(collection(db, "mahasiswa"), orderBy("createdAt", "desc"));
        const snapshot = await getDocs(q);
        const data = [];
        snapshot.forEach(doc => {
          data.push({ id: doc.id, ...doc.data() });
        });
        students.value = data;
      } catch (err) {
        console.error("Gagal load mahasiswa:", err);
      }
      isLoading.value = false;
    };

    onMounted(() => {
      const role = localStorage.getItem('user_role');
      if (role !== 'admin') {
        alert('Akses Ditolak! Hanya Admin yang boleh mengelola data mahasiswa.');
        router.replace('/dosen');
        return;
      }
      loadStudents();
    });

    const saveStudent = async () => {
      if (!newStudent.value.npm || !newStudent.value.nama) {
        alert("NPM dan Nama wajib diisi!");
        return;
      }
      isSaving.value = true;
      try {
        await addDoc(collection(db, "mahasiswa"), {
          npm: newStudent.value.npm,
          nama: newStudent.value.nama,
          createdAt: serverTimestamp()
        });
        showAddModal.value = false;
        newStudent.value = { npm: '', nama: '' };
        await loadStudents();
      } catch (err) {
        console.error("Gagal simpan mahasiswa:", err);
        alert("Gagal menyimpan mahasiswa.");
      }
      isSaving.value = false;
    };

    const deleteStudent = async (id) => {
      if(confirm('Yakin ingin menghapus mahasiswa ini?')) {
        try {
          await deleteDoc(doc(db, "mahasiswa", id));
          await loadStudents();
        } catch(e) {
          console.error(e);
        }
      }
    };

    const goTo = (path) => {
      router.push(path).catch(() => { window.location.href = path; });
      setTimeout(() => { if (window.location.pathname !== path) window.location.href = path; }, 100);
    };

    return {
      goTo,
      arrowBackOutline,
      addOutline,
      trashOutline,
      students,
      isLoading,
      showAddModal,
      newStudent,
      saveStudent,
      deleteStudent,
      isSaving
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap');

* {
  font-family: 'Poppins', sans-serif;
  box-sizing: border-box;
}

.dashboard-container {
  --background: #fdfdfd;
}

.transparent-toolbar {
  --background: transparent;
  padding: 10px 0;
}

.welcome-title {
  font-size: 1.3rem;
  font-weight: 700;
  color: #1f1f1f;
}

.highlight {
  color: #fca311;
}

.header-action {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.header-action p {
  color: #666;
  margin: 0;
  font-size: 0.9rem;
}

.btn-primary-small {
  background: #1f1f1f;
  color: #fff;
  border: none;
  padding: 8px 15px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 0.85rem;
  display: flex;
  align-items: center;
  gap: 5px;
  cursor: pointer;
}

.student-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.student-card {
  padding: 15px;
  border-radius: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid rgba(200, 200, 200, 0.2);
}

.std-info h3 {
  margin: 0 0 5px 0;
  font-size: 1rem;
  font-weight: 600;
  color: #1f1f1f;
}

.std-info p {
  margin: 0;
  font-size: 0.8rem;
  color: #777;
}

.btn-danger-small {
  background: #ffe3e3;
  color: #ff4d4f;
  border: none;
  padding: 8px 12px;
  border-radius: 8px;
  font-size: 1.2rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.glass-effect {
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  box-shadow: 0 4px 15px 0 rgba(0, 0, 0, 0.05);
}

/* Modal Styles sama dengan kelas */
.modal-overlay {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 20px;
}

.modal-content {
  background: white;
  width: 100%;
  max-width: 400px;
  padding: 20px;
  border-radius: 15px;
}

.modal-content h3 {
  margin-top: 0;
  margin-bottom: 20px;
  color: #1f1f1f;
  font-weight: 600;
}

.input-group {
  margin-bottom: 15px;
  text-align: left;
}

.input-group label {
  display: block;
  font-size: 0.85rem;
  color: #555;
  margin-bottom: 8px;
  font-weight: 500;
}

.custom-input {
  width: 100%;
  padding: 12px 15px;
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  font-size: 0.9rem;
  background: rgba(255, 255, 255, 0.8);
  outline: none;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}

.btn-outline {
  background: transparent;
  border: 1px solid #ccc;
  padding: 8px 15px;
  border-radius: 8px;
  font-weight: 600;
  color: #555;
}
</style>
